import React, { useEffect } from 'react';
import { type RenderChildrenProps, components } from '@atlassian/jira-command-palette';
import { useChildCommands } from '../../controllers';

export const CommandPaletteChildCommandBody = ({
	setChildResult,
	...rest
}: RenderChildrenProps) => {
	const [{ commands }] = useChildCommands();
	useEffect(() => {
		setChildResult({
			commands,
			sections: {},
		});
	}, [commands, setChildResult]);

	return <components.Body setChildResult={setChildResult} {...rest} />;
};
